export default __webpack_public_path__ + "static/media/BCA2.ec0a33d6.jpg";